interface UtcDateTimeInputProps {
  readonly label: string;
  readonly value: string;
  readonly placeholder?: string;
  readonly inputClassName?: string;
  readonly onChange: (value: string) => void;
}

const BASE_INPUT_CLASS =
  'rounded-md border border-outline-variant bg-surface px-3 py-2 text-sm normal-case tracking-normal text-on-surface';

export function UtcDateTimeInput({
  label,
  value,
  placeholder,
  inputClassName = '',
  onChange,
}: UtcDateTimeInputProps): JSX.Element {
  return (
    <label className="flex flex-col gap-1 text-xs font-semibold uppercase tracking-[0.12em] text-outline">
      {label}
      <input
        type="datetime-local"
        step={60}
        value={isoToUtcDateTimeLocal(value)}
        placeholder={isoToUtcDateTimeLocal(placeholder ?? '')}
        onChange={(event) => onChange(utcDateTimeLocalToIso(event.currentTarget.value))}
        className={`${BASE_INPUT_CLASS} ${inputClassName}`.trim()}
      />
    </label>
  );
}

export function isoToUtcDateTimeLocal(value: string): string {
  const ms = Date.parse(value);
  if (!Number.isFinite(ms)) return '';
  const d = new Date(ms);
  return [
    d.getUTCFullYear(),
    pad2(d.getUTCMonth() + 1),
    pad2(d.getUTCDate()),
  ].join('-') + `T${pad2(d.getUTCHours())}:${pad2(d.getUTCMinutes())}`;
}

export function utcDateTimeLocalToIso(value: string): string {
  if (value.length === 0) return '';
  const withSeconds = value.length === 16 ? `${value}:00` : value;
  const ms = Date.parse(`${withSeconds}Z`);
  if (!Number.isFinite(ms)) return '';
  return new Date(ms).toISOString().replace(/\.\d{3}Z$/, 'Z');
}

function pad2(value: number): string {
  return String(value).padStart(2, '0');
}
